import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createGroupe } from '../api/GROUPES/groupes';
import { toast } from 'react-toastify';

export const useCreateGroupe = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createGroupe,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['groupes'] });
            toast.success('Groupe créé avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la création du groupe');
        },
    });
};
